<template>
  <div id="cases" class="safe-custody-cases">
    <div class="safe-custody-cases-main" v-html="data.title"/>

    <div v-for="{img, text} in items" class="safe-custody-cases-item">
      <NuxtImg :src="img" :alt="text" format="webp" loading="lazy" />
      <p v-html="text" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/safe-custody')).blocks?.cases

const items = computed(() => [
  {
    img: '/images/pages/safe-custody/furniture.png',
    text: data.furniture
  },
  {
    img: '/images/pages/safe-custody/quad-bike.png',
    text: data.quadBike
  },
  {
    img: '/images/pages/safe-custody/machine.png',
    text: data.machine
  },
  {
    img: '/images/pages/safe-custody/instruments.png',
    text: data.instruments
  },
  {
    img: '/images/pages/safe-custody/shop.png',
    text: data.shop
  },
])
</script>

<style scoped lang="scss">
.safe-custody-cases {
  margin-top: 70px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;

  &-item {
    background-color: $box-gray;
    border-radius: 16px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: $font-low;
    font-weight: 500;
    p {
      padding: 10px 20px 0;
    }

    img {
      max-width: 100%;
    }
  }

  &-main {
    display: flex;
    flex-direction: column;
    justify-content: center;

    :deep(strong) {
      text-transform: uppercase;
      color: $primary;
      font-size: 26px;
      line-height: 36px;
    }
    :deep(p) {
      font-size: 23px;
      line-height: 36px;
      margin-bottom: 5px;
      font-weight: 500;
    }
  }

  @media screen and (max-width: $pub-md) {
    &-main {
      :deep(strong) {
        font-size: 22px;
      }
      :deep(p) {
        font-size: 19px;
      }
    }
  }

  @media screen and (max-width: $pub-sm) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
  }

  @media screen and (max-width: $pub-xs) {
    grid-template-columns: 1fr;
    &-item {
      padding: 20px 4px;
      img {
        width: 100%;
        max-width: 360px;
      }
    }
  }
}
</style>
